import React from 'react';
import type { Opportunity } from '../../types';

export function DeadlineProgressBar({
  opportunity,
  compact = false,
}: {
  opportunity: Pick<Opportunity, 'deadlineProgress' | 'displayStatus'>;
  compact?: boolean;
}) {
  const progress = opportunity.deadlineProgress;
  if (!progress || opportunity.displayStatus === 'closed') {
    return (
      <div className={`wfx-opp-deadline${compact ? ' is-compact' : ''}`}>
        <p className="wfx-muted">Application closed</p>
      </div>
    );
  }

  return (
    <div className={`wfx-opp-deadline${compact ? ' is-compact' : ''}`}>
      <div className="wfx-download-progress-track" role="progressbar" aria-valuenow={progress.percent} aria-valuemin={0} aria-valuemax={100}>
        <span style={{ width: `${progress.percent}%` }} />
      </div>
      <p className="wfx-opp-deadline-label">
        <strong>{progress.percent}%</strong>
        <span>{progress.label}</span>
      </p>
    </div>
  );
}
